<template>

</template>

<script>
import store from '../../store'
export default {
  name: 'ScrollHelper',

  async mounted () {
    await store.restored
    const el = document.getElementsByTagName('main')[0]

    el.scroll({
      top: 300,
      behavior: 'smooth'
    })
  }
}
</script>

<style scoped>

</style>
